import { render, staticRenderFns } from "./Quotation_web_site.vue?vue&type=template&id=f3b5bf32&scoped=true&"
import script from "./Quotation_web_site.vue?vue&type=script&lang=js&"
export * from "./Quotation_web_site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b5bf32",
  null
  
)

export default component.exports